import { ReportInputParameterKeys } from 'ag-common-lib/lib/contracts/reporting-api.contracts';

export const REPORT_VARIABLE_HELP_TEXT: Partial<Record<ReportInputParameterKeys, string>> = {
  [ReportInputParameterKeys.ntpDisplayMode]:
    'Controls whether NTP production is hidden from detail, displayed in a separate NTP section, or displayed in the general list. NTP production remains included in Grand Total in every mode.',
  [ReportInputParameterKeys.showSuppressedAgents]:
    'Controls whether suppressed agent names appear in Personal Production detail rows. Their production is always included in totals.',
  [ReportInputParameterKeys.showTotals]:
    'Displays the applicable section Total and Grand Total. Totals include production hidden by the display threshold, agent suppression, or NTP-detail visibility.',
};

export function getReportVariableHelpText(label: string): string {
  if (label === 'Show NTP Agents' || label === 'Show NTP Agencies')
    return REPORT_VARIABLE_HELP_TEXT[ReportInputParameterKeys.ntpDisplayMode] ?? '';
  if (label === 'Show Suppressed Agents')
    return REPORT_VARIABLE_HELP_TEXT[ReportInputParameterKeys.showSuppressedAgents] ?? '';
  if (label === 'Show Totals') return REPORT_VARIABLE_HELP_TEXT[ReportInputParameterKeys.showTotals] ?? '';
  return '';
}
